export const nextSeminarDate = () => {
  const now = new Date();
  const istNow = new Date(now.getTime() + (330 + now.getTimezoneOffset()) * 60000);
  const d = new Date(istNow);
  d.setDate(d.getDate() + ((6 - d.getDay() + 7) % 7 || 7));
  d.setHours(11, 0, 0, 0);
  return new Date(d.getTime() - (330 + now.getTimezoneOffset()) * 60000);
};

const toCal = (d) =>
  `${d.getUTCFullYear()}${String(d.getUTCMonth() + 1).padStart(2, "0")}${String(d.getUTCDate()).padStart(2, "0")}T${String(d.getUTCHours()).padStart(2, "0")}${String(d.getUTCMinutes()).padStart(2, "0")}00Z`;

export const calendarLink = () => {
  const start = nextSeminarDate();
  const end = new Date(start.getTime() + 90 * 60000);
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: "Free Live Seminar: Tech Careers in AI, Cybersecurity & Data Science",
    dates: `${toCal(start)}/${toCal(end)}`,
    details: "Your free seat is reserved. Joining link will be shared on your email/phone before the seminar.",
    location: "Online (Live)",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const seminarDateLabel = () => {
  const d = nextSeminarDate();
  return d.toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long", timeZone: "Asia/Kolkata" });
};
